<template>
	<div
		v-if="isActive"
		class="tab scroll"
		data-cy="tab"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Tab',

	props: {
		active: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets wether or not the current tab is selected and show its content',
		},

		icon: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the icon that will appear on the tab',
		},

		iconWeight: {
			type: String,
			required: false,
			default: 'regular',
			description: 'Sets the weight of the icon in the tab',
		},

		name: {
			type: String,
			required: true,
			description: 'Sets the name that appears in the tab',
		},

		notificationCount: {
			type: Number,
			required: false,
			default: null,
			description: 'Sets the number of notifications that will appear in the tab',
		},
	},

	data() {
		return {
			isActive: false,
		};
	},

	watch: {
		active(newActiveState) {
			this.isActive = newActiveState;
			window.dispatchEvent(new Event('resize'));
		},
	},

	mounted() {
		this.isActive = this.active;
	},
};
</script>

<style lang="scss" src="./tab.scss" />
